
  var _styles = {
  "phx-poi-lis-card-wrap": {
    "display": "flex",
    "width": "100%",
    "justifyContent": "space-between",
    "flexDirection": "row",
    "flexWrap": "wrap"
  },
  "phx-poi-lis-container": {
    "width": "100%",
    "paddingLeft": "0.16rem",
    "paddingRight": "0.16rem",
    "display": "flex",
    "flexDirection": "column"
  },
  "phx-poi-lis-show-more-text": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(34,34,34)",
    "letterSpacing": 0,
    "lineHeight": "0.45333rem"
  },
  "phx-poi-lis-show-more-arrow-container": {
    "transform": "rotate(180deg)"
  },
  "phx-poi-lis-show-more-arrow": {
    "lineHeight": "0.26667rem",
    "color": "rgb(85,85,85)"
  },
  "phx-poi-lis-show-more-button": {
    "width": "2.24rem",
    "height": "0.8rem",
    "background": "#fff",
    "marginTop": "0.32rem",
    "borderRadius": "0.4rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "phx-poi-lis-show-more-container": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "phx-poi-lis-no-more-container": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "phx-poi-lis-no-more-text": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(153,153,153)",
    "letterSpacing": 0,
    "lineHeight": "0.4rem"
  },
  "phx-poi-lis-load-more-sensor": {
    "height": "0.8rem",
    "width": "100%",
    "opacity": 0
  },
  "phx-poi-lis-no-data-container": {
    "display": "flex",
    "width": "100%",
    "height": "10rem",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "phx-poi-lis-no-data-text": {
    "fontFamily": "PingFangSC-Regular",
    "width": "8.66667rem",
    "textAlign": "center"
  },
  "phx-poi-lis-no-data-img": {
    "marginTop": "0.16rem",
    "width": "100%"
  },
  "phx-poi-lis-row-type-show-more-button": {
    "marginLeft": "0.26667rem",
    "display": "flex",
    "justifyContent": "center"
  },
  "phx-poi-lis-row-type-show-more-view": {
    "width": "0.66667rem",
    "paddingTop": "0.26667rem",
    "paddingRight": "0.06667rem",
    "paddingBottom": "0.26667rem",
    "paddingLeft": "0.06667rem",
    "borderRadius": "0.33333rem",
    "backgroundColor": "rgba(0,0,0,0.4)"
  },
  "phx-poi-lis-row-type-show-more-text": {
    "color": "rgb(255,255,255)",
    "fontSize": "small",
    "textAlign": "center"
  }
};



  module.exports = _styles;
  